import React, { useState } from "react";
import axios from "axios"
import { Auth } from "aws-amplify";
import { CSVLink } from "react-csv";
import { AlertTitle, Button, Chip, CircularProgress, Divider, FormControl, InputLabel, MenuItem, Select, Snackbar, Tab, Tabs, TextField } from "@mui/material";
import MuiAlert from '@mui/material/Alert';
import { useTranslation, Trans } from "react-i18next";

import FileDownloadIcon from '@mui/icons-material/FileDownload';

import Table from "../../TableComponent";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="standard" {...props} />;
});

const Dropbox = ({adminInfo}) => {
  
  const [toastOpen, setToastOpen] = useState(false);
  const [toastType, setToastType] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  const [studentForm, setStudentForm] = useState({orgStudId: ""});
  const [studentFormError, setStudentFormError] = useState({orgStudId: false});
  const [studentFormState, setStudentFormState] = useState(false);
  const [studentData, setStudentData] = useState("")
  const [importForm, setImportForm] = useState({"school": adminInfo.admin.schools[0].id, std: "", divn: "", rollNo: ""});
  const [importFormError, setImportFormError] = useState({rollNo: false});
  const [importFormState, setImportFormState] = useState(false);
  const [dropboxStudentsData, setDropboxStudentsData] = useState("");

  const { t } = useTranslation()

  const orderBy = [];
  const columns = [
    {
      key: "studentName",
      headerName: t("commonItems.tableHeader_studentName"),
      width: 80
    },
    {
      key: "orgStudId",
      headerName: t("commonItems.tableHeader_orgStudId"),
      width: 80
    },
    // {
    //   key: "penNo",
    //   headerName: "Student PEN",
    //   width: 80
    // },
    // {
    //   key: "std",
    //   headerName: "Class",
    //   width: 30
    // },
    // { 
    //   key: "divn", 
    //   headerName: "Section", 
    //   width: 30 
    // },
    { 
      key: "classSection", 
      headerName: t("commonItems.tableHeader_classSection"), 
      width: 30 
    },
    // { 
    //   key: "rollNo", 
    //   headerName: "Roll No", 
    //   width: 30 
    // },
    { 
      key: "gender", 
      headerName: t("commonItems.tableHeader_gender"), 
      width: 30 
    },
    { 
      key: "status", 
      headerName: t("admin.dropbox.tableHeader_remark"), 
      width: 30 
    },
  ];

  const headers = [
    { label: "Org Student Id", key: "orgStudId"},
    { label: "Class", key: "std" },
    { label: "Section", key: "divn" },
    { label: "Student Name", key: "studentName" },
    { label: "Gender", key: "gender" },
    // { label: "Student PEN (Maximum 12 digit)", key: "penNo"},
    // { label: "Roll No", key: "rollNo" },
    { label: "Remark", key: "status" }
  ];

  const handleToastClose = (event, reason) => {
    if (reason === 'clickaway') return
    setToastOpen(false);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    if(newValue===1){
      Auth.currentSession()
      .then((data) => {
        const jwtToken = data.idToken.jwtToken;

        const getDropboxStudentsData = async(adminId) => {
          try {
            const response =  await axios.get("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/admin/"+adminId+"/dropbox-export", {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': jwtToken
                }
            });
            // console.log(response.data)
            // adding full name by combining firstName and lastName
            const studentsData = response.data["students"].map(item => ({
              ...item, 
              "studentName": item["studentName"].toUpperCase(),
              "classSection": item["std"] + "-" + item["divn"],
              "status": item["status"] === 0 ? "Left School with TC" : "Long Absentee"
            }))
            setDropboxStudentsData(studentsData)
          }
          catch (error) {
            setToastType(["error", t("commonItems.error_api_generic")])
            setToastOpen(true)
            console.log(error)
          }
        }
        getDropboxStudentsData(adminInfo.admin.adminId)
      })
      .catch((err) => console.log(err));
    }
  };

  const handleStudentFormChange = (field, value) => {
    // console.log(value)
    setStudentForm(prev => ({...prev, [field]: value}))
    if(field === "orgStudId"){
      // This checks that orgStudId contains only 10 to 12 digit numbers & checks for any whitespace character at the start of string
      if((/^(?!\s)(\d{10,12})$/).test(value)) setStudentFormError(prev => ({...prev, [field]: false}))   // \d is same as 0-9
      else setStudentFormError(prev => ({...prev, [field]: true}))
    }
  }

  const handleStudentForm = () => {
    if(!(/^(?!\s)(\d{10,12})$/).test(studentForm.orgStudId)) {
      setToastType(["warning", t("commonItems.error_requiredFields")])
      setToastOpen(true)
      return
    }
    setStudentData("")
    setImportForm({"school": adminInfo.admin.schools[0].id, std: "", divn: "", rollNo: ""})
    setStudentFormState(true)

    const adminId = adminInfo.admin.adminId
    const orgStudId = studentForm.orgStudId
    
    Auth.currentSession()
    .then(async (data) => {
      const jwtToken = data.idToken.jwtToken;

      try {
        const getResponse =  await axios.get("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/admin/"+adminId+"/dropbox-import?orgStudId="+orgStudId, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
          }
        });
        // console.log("get Response: ",getResponse.data)
        setStudentData(getResponse.data)
        setStudentFormState(false)
      }
      catch (error) {
        if ([400, 405, 406].includes(error.response.status)) setToastType(["error", error.response.data.message])
        else{
          console.log(error)
          setToastType(["error", t("commonItems.error_api_generic")])
        }
        setToastOpen(true)
        setStudentFormState(false)
      }
    })
    .catch((err) => console.log(err));
  }

  const handleImportFormChange = (field, value) => {
    // console.log(value)
    setImportForm(prev => ({...prev, [field]: value}))
    if(field === "rollNo"){
      // This checks that rollNo contains only numbers & checks for any whitespace character at the start of string
      // if(!(/^(?!\s)(\d{1,99})$/).test(value)) setImportFormError(prev => ({...prev, [field]: true}))   // \d is same as 0-9
      if(value>0 && value <= 99) setImportFormError(prev => ({...prev, [field]: false}))   
      else setImportFormError(prev => ({...prev, [field]: true}))
    }
  }

  const handleImportForm = () => {
    if(!(importForm.rollNo>0 && importForm.rollNo <= 99) || !(importForm.school) || !(importForm.std) || !(importForm.divn)) {
      setToastType(["warning", t("commonItems.error_requiredFields")])
      setToastOpen(true)
      return
    }
    
    if(!adminInfo.test){
      setToastType(["warning", t("commonItems.error_testNotStarted")])
      setToastOpen(true)
      return
    }

    const adminId = adminInfo.admin.adminId
    
    setImportFormState(true)
    
    Auth.currentSession()
    .then(async (data) => {
      const jwtToken = data.idToken.jwtToken;

      try {
        const postResponse =  await axios.post("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/admin/"+adminId+"/dropbox-import", 
          JSON.stringify({
            "studId": studentData.studId,
            "schoolId": importForm.school,
            "std": importForm.std,
            "divn": importForm.divn,
            "rollNo": importForm.rollNo
          }), 
          {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
          }
        });
        // console.log("post Response: ",postResponse.data)
        alert(t("admin.dropbox.info_importSuccess"));
        setToastType(["success", postResponse.data.message])
        setToastOpen(true)
        setStudentForm({orgStudId: ""})
        setImportForm({"school": adminInfo.admin.schools[0].id, std: "", divn: "", rollNo: ""})
        setStudentData("")
        setImportFormState(false)
      }
      catch (error) {
        if ([405, 406, 422].includes(error.response.status)) setToastType(["error", error.response.data.message])
        else{
          console.log(error)
          setToastType(["error", t("commonItems.error_api_generic")])
        }
        setToastOpen(true)
        setImportFormState(false)
      }
    })
    .catch((err) => console.log(err));
  }

  return (
    <div className="dropbox" style={{display: "flex", flexDirection: "column", gap: "0.5rem"}}>
      <Snackbar open={toastOpen} autoHideDuration={5000} onClose={handleToastClose}>
        <Alert onClose={handleToastClose} severity={toastType[0]} sx={{ width: '100%' }}>
        {toastType[1]}
        </Alert>
      </Snackbar>
      <h2 style={{textAlign: "center", color: "#0288D1", borderRadius: "15px", border: "1px solid"}}>
        {t("admin.dropbox.title")}
      </h2>
      <div className="tabs" style={{display: "flex"}}>
        <Tabs value={tabValue} onChange={handleTabChange} sx={{minHeight: "30px"}}>
          <Tab label={t("admin.dropbox.tabLabel_import")} sx={{fontSize: "inherit", minHeight: "30px"}}/>
          <Tab label={t("admin.dropbox.tabLabel_studentList")} sx={{fontSize: "inherit", minHeight: "30px"}}/>
        </Tabs>
      </div>
      {tabValue===0 &&
        <>{(adminInfo.test ? adminInfo.test.status===1 : false) ?
          <>
            <div className="forms">
              <FormControl sx={{ m: 1, minWidth: 150}}>
                <TextField
                  error = {studentFormError.orgStudId} 
                  // helperText = {studentFormError.orgStudId ? t("admin.dropbox.error_invalidOrgStudId") : false} 
                  helperText = {studentFormError.orgStudId ? "Org Student Id must have 10 to 12 digits number." : false} 
                  autoFocus
                  required
                  // margin="dense"
                  id="orgStudId"
                  name={t("commonItems.textfieldLabel_orgStudId")}
                  label={t("commonItems.textfieldLabel_orgStudId")}
                  fullWidth
                  variant="outlined"
                  size="small"
                  value={studentForm.orgStudId}
                  onChange={(e) => handleStudentFormChange("orgStudId", e.target.value)}
                />
              </FormControl>
              <Button 
                color="info" 
                variant="contained" 
                sx={{m: 1}} 
                disabled={studentFormError.orgStudId || studentFormState}
                onClick={handleStudentForm}
              >
                {t("admin.dropbox.buttonLabel_search")}{studentFormState ? <CircularProgress size="1rem" color="inherit" sx={{marginLeft: "0.25rem"}}/> : ""}
              </Button>
            </div>
            {studentData 
            ?
              <>
                <div className="dropboxDetails" style={{display: "flex", gap:"1rem", backgroundColor: "#F1F3F9", borderRadius: "10px", padding: "1rem"}}>
                  <div style={{display: "flex", flexDirection: "column", flex: "0.7", gap: "0.5rem"}}>
                    <h4>{t("admin.dropbox.importDetails_studentStatus")}: {studentData.dropbox ? 
                      <>
                        <Chip label="In Dropbox" color='success' sx={{mr: 1}}/> 
                        {studentData.status ? <Chip label="Long Absentee" color='warning'/> : <Chip label="Left School with TC" color='success'/>}
                      </>
                      : <Chip label="Not in Dropbox" color='error'/>
                    }</h4>
                    <h4>{t("commonItems.textLabel_studentBasicDetails")}:</h4>
                    <p>{t("commonItems.textLabel_studentName")}: <span style={{fontWeight: 600}}>{studentData.studentName}</span></p>
                    <p>{t("commonItems.textLabel_gender")}: <span style={{fontWeight: 600}}>{studentData.gender === "M" ? "Male" : "Female"}</span></p>
                    <p>{t("commonItems.textLabel_orgStudId")}: <span style={{fontWeight: 600}}>{studentData.orgStudId}</span></p>
                  </div>
                  <Divider orientation="vertical" flexItem/>
                  <div style={{display: "flex", flexDirection: "column", gap: "0.5rem"}}>
                    <h4>{t("commonItems.textLabel_currentSchoolDetails")}:</h4>
                    <p>{t("commonItems.textLabel_class")}: <span style={{fontWeight: 600}}>{studentData.std}</span></p>
                    {/* <p>School Code: {studentData.schoolId.slice(2,6)}</p> */}
                    <p>{t("commonItems.textLabel_school")}: <span style={{fontWeight: 600}}>{studentData.name} Shift {studentData.shift}</span></p>
                    <p>{t("commonItems.textLabel_region")}: <span style={{fontWeight: 600}}>{studentData.region}</span></p>
                  </div>
                </div>
                {studentData.dropbox 
                ?
                  <>
                    {studentData.status ? // only allow for long absentee case (status = 1)
                      <>
                        <div style={{display: "flex", flexDirection: "column", gap: "1rem", backgroundColor: "#F1F3F9", borderRadius: "10px", padding: "1rem"}}>
                          <h4>{t("admin.dropbox.importDetails_importStudent")}:</h4>
                          <div style={{display: "flex", flexWrap: "wrap" , gap: "1rem"}}>
                            <FormControl sx={{minWidth: 150 }} size="small">
                              <InputLabel id="schoolFilterLabel">{t("commonItems.dropdownLabel_school")}</InputLabel>
                              <Select
                                labelId="schoolFilterLabel"
                                id="schoolFilter"
                                value={importForm.school}
                                onChange={(e) => handleImportFormChange("school", e.target.value)}
                                autoWidth
                                label={t("commonItems.dropdownLabel_school")}
                              >
                                {/* <MenuItem value="">
                                  <em>None</em>
                                  </MenuItem> */}
                                {/* getting all unique divn values from data */}
                                { adminInfo &&
                                  adminInfo.admin.schools.map((item, i) => {
                                    return <MenuItem key={i} value={item.id}>{item.name}</MenuItem>
                                  })
                                }
                              </Select>
                            </FormControl>
                            <FormControl sx={{minWidth: 150}} size="small">
                              <InputLabel id="stdFilterLabel">{t("commonItems.dropdownLabel_class")}</InputLabel>
                              <Select
                                labelId="stdFilterLabel"
                                id="stdFilter"
                                value={importForm.std}
                                onChange={(e) => handleImportFormChange("std", e.target.value)}
                                autoWidth
                                label={t("commonItems.dropdownLabel_class")}
                              >
                                {/* <MenuItem value="">
                                  <em>None</em>
                                </MenuItem> */}
                                {Object.keys(studentData.adminClassDetails).includes(String(studentData.std)) && 
                                  <MenuItem value={studentData.std} selected>{studentData.std}</MenuItem>}
                                {/* {(studentData.std !==8 && Object.keys(studentData.adminClassDetails).includes(String(studentData.std+1))) && 
                                  <MenuItem value={studentData.std+1}>{studentData.std+1}</MenuItem>} */}
                                {/* {!(Object.keys(studentData.adminClassDetails).includes(String(studentData.std)) || Object.keys(studentData.adminClassDetails).includes(String(studentData.std+1))) && 
                                  <MenuItem disabled>Class not available</MenuItem>} */}
                                {!(Object.keys(studentData.adminClassDetails).includes(String(studentData.std))) && 
                                  <MenuItem disabled>Class not available</MenuItem>}
                              </Select>
                            </FormControl>
                            <FormControl sx={{ minWidth: 150}} size="small">
                              <InputLabel id="divnFilterLabel">{t("commonItems.dropdownLabel_section")}</InputLabel>
                              <Select
                                labelId="divnFilterLabel"
                                id="divnFilter"
                                value={importForm.divn}
                                onChange={(e) => handleImportFormChange("divn", e.target.value)}
                                autoWidth
                                label={t("commonItems.dropdownLabel_section")}
                              >
                                {/* <MenuItem value="">
                                  <em>None</em>
                                  </MenuItem> */}
                                {importForm.std ? 
                                  studentData.adminClassDetails[importForm.std].map((item, i) => {
                                    return <MenuItem key={i} value={item}>{item}</MenuItem>
                                  })
                                :
                                  <MenuItem disabled>Select Std First</MenuItem>
                                }  
                              </Select>
                            </FormControl>
                            <FormControl sx={{ minWidth: 150}} size="small">
                              <TextField
                                error = {importFormError.rollNo} 
                                helperText = {importFormError.rollNo ? t("admin.dropbox.error_invalidRollNo") : false} 
                                required
                                // margin="dense"
                                id="rollNo"
                                name={t("commonItems.textfieldLabel_rollNo")}
                                label={t("commonItems.textfieldLabel_rollNo")}
                                // fullWidth
                                variant="outlined"
                                size="small"
                                value={importForm.rollNo}
                                onChange={(e) => handleImportFormChange("rollNo", e.target.value)}
                              />
                            </FormControl>
                            <Button 
                              color="info" 
                              variant="contained" 
                              disabled={importFormState || importFormError.std || importFormError.divn || importFormError.rollNo} 
                              onClick={handleImportForm}
                            >
                              {t("admin.dropbox.buttonLabel_import")}{importFormState ? <CircularProgress size="1rem" color="inherit" sx={{marginLeft: "0.25rem"}}/> : ""}
                            </Button>
                          </div>
                        </div>
                        <MuiAlert severity="info" className="uploadInstructions">
                          <AlertTitle>
                            <b>
                              <Trans 
                                i18nKey={"admin.dropbox.importDetails_importInfo_valid"}
                                components={{
                                  1: <Chip label="In Dropbox" color='success'/>
                                }}
                              />
                           </b>
                          </AlertTitle>
                        </MuiAlert>
                      </>
                    :
                      <MuiAlert severity="error" className="uploadInstructions">
                        <AlertTitle>
                          <b>
                            <Trans 
                              i18nKey={"admin.dropbox.importDetails_importInfo_valid_KVLeftTC"}
                              components={{
                                1: <Chip label="Left School with TC" color='success'/>
                              }}
                            />
                          </b>
                        </AlertTitle>
                      </MuiAlert>
                    }
                  </>
                :
                  <MuiAlert severity="error" className="uploadInstructions">
                    <AlertTitle>
                      <b>
                        <Trans 
                          i18nKey={"admin.dropbox.importDetails_importInfo_invalidLine1"}
                          components={{
                            1: <Chip label="Not in Dropbox" color='error'/>
                          }}
                        />
                      </b>
                    </AlertTitle>
                    <p>{t("admin.dropbox.importDetails_importInfo_invalidLine2")}</p>
                  </MuiAlert>
                }
              </>
            :
              <MuiAlert severity="info" className="uploadInstructions">
                <AlertTitle><b>{t("admin.dropbox.info_getStudentDetails")}</b></AlertTitle>
              </MuiAlert>
            }
          </>
        :
          <MuiAlert severity="error">
            <AlertTitle><b>{t("admin.dropbox.info_droboxNotAvailable")}</b></AlertTitle>
          </MuiAlert>
        }</>
      }
      {tabValue === 1 &&
        <div>
          {dropboxStudentsData 
            ? 
            <div className="studentsContent innerContent">
              <MuiAlert severity="info" className="uploadInstructions">
                <AlertTitle><b>{t("admin.dropbox.info_studentList")}</b></AlertTitle>
              </MuiAlert>
              <div className="tabs" style={{paddingTop: "0.5rem"}}>
                <Button variant="contained" color="info" startIcon={<FileDownloadIcon />} sx={{ placeSelf: "start" }}>
                  <CSVLink data={dropboxStudentsData} headers={headers} filename={"DropboxStudentsData.csv"}>
                    {t("commonItems.buttonLabel_csvDownload")}
                  </CSVLink>
                </Button>
              </div>
              <Divider />
              <div className="table">
                <Table
                  columns={columns}
                  tableData={dropboxStudentsData}
                  orderBy={orderBy}
                  tableHeight="calc(100vh - 378px)"
                />
              </div>
            </div>
          :
            <div style={{display: "flex", alignItems: "center", justifyContent: "center", height: "60vh"}}><CircularProgress color="info"/></div>
          }
        </div>
      }
    </div>
  );
};

export default Dropbox;